import React, { useEffect, useState } from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { BusinessPage } from "core/constants";
import ApplicationAction from "core/constants/application-action";
import { useUpdatePage } from "core/hooks";
import { sessionManager } from "core/instances";
import { LocalStorageHelper } from "core/lib/local-storage-helper";
import UrlUtils from "core/lib/url-utils";
import { Notice, ModalAlert } from "components/common-ui";

const ChildSignUp = (props: any) => {
    const { independentSignUp } = props;
    const [updateTitle,] = useUpdatePage();
    const [customerAccountNumber, setCustomerAccountNumber] = useState<string | null>(null);

    const customerIdQueryParam = "c_id";

    const pageTitle = "Redirecting to Sign Up";

    const action = independentSignUp ? ApplicationAction.childIndependentSignUp : ApplicationAction.childSignUp;

    const root = UrlUtils.getRootPath();
    const returnUrl = `${root}${BusinessPage.accountCreated.substring(1)}?action=${action}`;

    const gotoSignUp = () => {
        const accountNumber = (document.getElementById("customerAccountNumberInput") as HTMLInputElement).value?.trim();

        if (accountNumber === null || accountNumber.length === 0) {
            ModalAlert.error("Please enter your customer account number");
            return;
        }

        setCustomerAccountNumber(accountNumber);
    }

    useEffectOnce(() => {
        updateTitle(pageTitle);

        const customerNumber = UrlUtils.getParameterByName(customerIdQueryParam);

        if (customerNumber == null) {
            return;
        }

        setCustomerAccountNumber(customerNumber);
    });

    useEffect(() => {
        if (customerAccountNumber == null) {
            return;
        }

        LocalStorageHelper.clearLog();
        LocalStorageHelper.logout();
        // SessionManager.setValidateSalesForce(false);
        sessionManager.campaignData = { customerNumber: customerAccountNumber };

        sessionManager.signUp(returnUrl);
    }, [customerAccountNumber]);

    if (!customerAccountNumber || independentSignUp) {
        return (
            <Notice>
                <p>
                    <strong>Welcome to the DStv Business Self Service Sign Up</strong>
                </p>
                <p>
                    Please enter your Customer Number to initiate your sign up
                </p>
                <p>
                    <strong>Step 1 of 3</strong>
                </p>
                <p>
                    <input type="text" id="customerAccountNumberInput" />
                </p>
                <p className="mb-0">
                    <button className="btn" onClick={gotoSignUp}>Go to sign up</button>
                </p>
            </Notice>
        );
    }

    return (
        <Notice showSpinner={true}>
            <p>
                Redirecting to sign up
            </p>
        </Notice>
    );
}

export default ChildSignUp;
